// Import the base functionality
import { WDHTabbedDataList } from '../../../../wdh-feature/wdh-tabbed-data-list';
var tabbedDataList = new WDHTabbedDataList();
tabbedDataList.run();